export default "__VITE_ASSET__CPPARvTI__"